import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InfoTooltipComponent, TableColumn, BubbleDirective } from '@ui/aos-lib';
import { DeviceConfigRequestStatus } from '../../devices/constants/devices.constants';
import { TwoWayRequestItemListResponseDto } from '../services/request-processing.types';
import { commandStatusBubbleMap, commandStatusLabelMap, commandStatusTooltipMap } from './command-status.constants';

@Component({
  selector: 'aos-command-status-column',
  template: `
    @if (item) {
      @let status = getCommandStatus(item.commandStatus);
      @if (status) {
        <ui-info-tooltip [text]="commandStatusTooltipMap[status] | translate">
          <span
            popoverContent
            [uiBubble]="commandStatusBubbleMap[status]"
          >
            {{ commandStatusLabelMap[status] | translate }}
          </span>
        </ui-info-tooltip>
      } @else {
        <span>{{ item.commandStatus }}</span>
      }
    }
  `,
  imports: [TranslateModule, InfoTooltipComponent, BubbleDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommandStatusColumnComponent {
  @Input() item!: TwoWayRequestItemListResponseDto;
  @Input() column!: TableColumn;

  protected readonly commandStatusLabelMap = commandStatusLabelMap;
  protected readonly commandStatusTooltipMap = commandStatusTooltipMap;
  protected readonly commandStatusBubbleMap = commandStatusBubbleMap;

  protected getCommandStatus(
    status: TwoWayRequestItemListResponseDto['commandStatus']
  ): DeviceConfigRequestStatus | null {
    return Object.values(DeviceConfigRequestStatus).includes(status as DeviceConfigRequestStatus)
      ? (status as DeviceConfigRequestStatus)
      : null;
  }
}
